module.exports = __webpack_public_path__ + "img/logoWhite.d9e7e183.svg";